function transFormatDate(d) {
    let yy = d.getFullYear(); // 年
    let mm = d.getMonth() + 1; // 月。
    let dd = d.getDate(); // 日
    let hh = d.getHours(); // 小时
    let min = d.getMinutes(); // 分钟
    mm = mm < 10 ? '0' + mm : mm
    dd = dd < 10 ? '0' + dd : dd
    hh = hh < 10 ? '0' + hh : hh
    min = min < 10 ? '0' + min : min
    let ss = d.getSeconds(); // 秒
    ss = ss < 10 ? '0' + ss : ss
    // let qq = Math.floor((d.getMonth() + 3) / 3); // 季度
    // let sss = d.getMilliseconds(); // 毫秒
    // console.log(yy + "-" + mm + "-" + dd + " " + hh + ":" + min + ":" + ss)
    // return yy + "-" + mm + "-" + dd + " " + hh + ":" + min + ":" + ss;
    return yy + "-" + mm + "-" + dd + " " + hh + ":" + min + ":" + ss;
}
// 获取今天的年月日17时30分
function getNowDay() {
    let timenow = new Date()
    let yy = timenow.getFullYear(); // 年
    let mm = timenow.getMonth() + 1; // 月。
    let dd = timenow.getDate(); // 日
    mm = mm < 10 ? '0' + mm : mm
    dd = dd < 10 ? '0' + dd : dd
    // let ss = d.getSeconds(); // 秒
    // let qq = Math.floor((d.getMonth() + 3) / 3); // 季度
    // let sss = d.getMilliseconds(); // 毫秒
    // console.log(yy + "-" + mm + "-" + dd + " " + hh + ":" + min + ":" + ss)
    // return yy + "-" + mm + "-" + dd + " " + hh + ":" + min + ":" + ss;
    return yy + "-" + mm + "-" + dd + " " + 17 + ":" + 30 + ":00";
}

// 获取昨天的年月日17时30分
function getYesterday() {
    let timenow = new Date()
    timenow.setDate(timenow.getDate() - 1);
    let yy = timenow.getFullYear() // 年
    let mm = timenow.getMonth() + 1; // 月。
    let dd = timenow.getDate(); // 日
    mm = mm < 10 ? '0' + mm : mm
    dd = dd < 10 ? '0' + dd : dd
    return yy + "-" + mm + "-" + dd + " " + 17 + ":" + 30 + ":00";
}
export { transFormatDate, getNowDay, getYesterday }